export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {
            type: Boolean,
            required: true,
        }
    },
    computed: {
        visible: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('update', value);
            }
        }
    },
    methods: {
        close() {
            this.visible = false
        },
        open() {
            this.visible = true
        },
    },
}
